module.exports = __webpack_public_path__ + "img/5.be676d52.png";